export default __webpack_public_path__ + "static/media/jenis-7.a6f3a63d.png";